import { render, staticRenderFns } from "./user_card_stat.vue?vue&type=template&id=343e2d90&scoped=true&"
import script from "./user_card_stat.vue?vue&type=script&lang=js&"
export * from "./user_card_stat.vue?vue&type=script&lang=js&"
import style0 from "./user_card_stat.vue?vue&type=style&index=0&id=343e2d90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343e2d90",
  null
  
)

export default component.exports